
import React from 'react';
import CategoryDropdown from 'Components/CategoryDropdown/CategoryDropdown';
import { FormattedMessage } from 'react-intl';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  sections: Julius.Website.SectionCategoryViewModel[];
  currentSectionID: number;
  onSelect: (id: number) => void;
}

interface IState {
  warning: {
    isVisible: boolean;
    seatsLeft: number;
  };
}

class PickTime extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      warning: {
        isVisible: false,
        seatsLeft: 10,
      },
    }
  }

  onSelect = (id: number) => {
    const section = this.props.sections.find(s => s.id === id);

    if (section.availableSeats < 10 && !this.state.warning.isVisible) {
      this.setState({ warning: { isVisible: true, seatsLeft: section.availableSeats } });
    }

    if (section.availableSeats >= 10 && this.state.warning.isVisible) {
      this.setState({ warning: { isVisible: false, seatsLeft: 10 } });
    }

    this.props.onSelect(id);
  }

  render() {
    return (
      <div className='pick-time'>
        <FormattedText 
          style='sub-title medium-bold'
          formattedName='order.picktime'  
          displayName='Välj tid'
        />
        <CategoryDropdown 
          categories={ this.props.sections }
          selectedCategoryID={ this.props.currentSectionID }
          onSelect={ this.onSelect }
        />
        { this.state.warning.isVisible &&
          <span className='timeslot-availability'>
            <FormattedMessage
              id='order.seatpicker.timeslots.fewseats'
              defaultMessage='Observera att det endast finns ett fåtal platser kvar för denna tid.'
              values={ { availableSeats: this.state.warning.seatsLeft } }
            />
          </span>
        }
      </div>
    );
  }
}

export default PickTime;


// WEBPACK FOOTER //
// ./src/components/PickSeatAutomatic/PickTime.tsx